import { hideAllPoppersInstantly } from "helpers/randomHelpers";
import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import {
  goToEffice,
  selectCurrentActiveAlive,
  selectGoToLoading,
} from "slices/efficeTreeSlice";
import ExtraOptionsAvatar from "./ExtraOptions/ExtraOptionsAvatar";
import RenderedRootList from "./RenderedRootList/RenderedRootList";
import FullLogoLightCorner from "graphics/Branding/FullLogoLightCorner.svg";
import HelperTip from "components/HOCS/HelperTip";
import HlpCentralEffices from "components/HelpSlides/HlpCentralEffices";
import { FM_CENTRALEFFICES, FM_GOHOME } from "helpers/freshman";
import EfsTippy from "components/HOCS/EfsTippy";
import HlpGoHome from "components/HelpSlides/InEffice/HlpGoHome";
import Spinner from "components/General-UI/Spinner";

const RootBar = () => {
  const currentActiveAlive = useSelector(selectCurrentActiveAlive);
  const ref = useRef(null);
  const goToLoading = useSelector(selectGoToLoading);

  useEffect(() => {
    let elem = ref.current;
    if (elem) elem.addEventListener("scroll", hideAllPoppersInstantly);
    return () => {
      elem.removeEventListener("scroll", hideAllPoppersInstantly);
    };
  }, []);
  return (
    <div className={`sidebar ${currentActiveAlive ? "minimised" : ""}`}>
      <HelperTip
        component={<HlpGoHome />}
        code={FM_GOHOME}
        placement="right"
        offset={[0, 6]}
        arrowWhite
      >
        <div>
          <EfsTippy
            placement="right"
            className="root-Tippy"
            disabled={!currentActiveAlive}
            content={"Home"}
          >
            <div
              className={`effice-space-home-corner-logo ${
                currentActiveAlive ? "only-logo-mark" : ""
              }`}
              onClick={() => goToEffice("home")}
            >
              <img
                alt="logo"
                src={FullLogoLightCorner}
                style={{ height: "35px" }}
              />
            </div>
          </EfsTippy>
        </div>
      </HelperTip>

      <HelperTip
        code={FM_CENTRALEFFICES}
        placement="right-start"
        component={<HlpCentralEffices />}
        offset={[10, 10]}
      >
        <div className="head-effice-head-list" ref={ref}>
          <div className="topbar-loader">
            {goToLoading ? (
              <Spinner spinnerLight={true} />
            ) : (
              <div
                className="effice-list-heading"
                style={{ visibility: currentActiveAlive ? "hidden" : "" }}
              >
                Your Effices:
              </div>
            )}
          </div>

          <RenderedRootList currentActiveAlive={currentActiveAlive} />
        </div>
      </HelperTip>

      <ExtraOptionsAvatar currentActiveAlive={currentActiveAlive} />
    </div>
  );
};

export default RootBar;
